module.exports = __webpack_public_path__ + "img/workforce-kit-app-logo.ec768009.svg";